"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoxStyled = void 0;

var _const = require("../../const");

var _utils = require("../../utils");

var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BoxStyled = (0, _utils.styled)('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return (0, _const.combineStyle)(props);
});
exports.BoxStyled = BoxStyled;